import type { ReactNode } from 'react';
import cx from 'classnames';

import styles from './AcceptAndConfirm.scss';

export const AcceptAndConfirmSaleSticky = ({ children, visible }: { children: ReactNode; visible: boolean }) => (
  <div className={cx(styles.sticky, { [styles.visible]: visible })}>
    {children}
  </div>
);
